import * as types from './constants';

export const billingSubscriptionCancelRequest = payload => ({ type: types.BILLING_SUBSCRIPTION_CANCEL_REQUEST, payload });
export const billingSubscriptionCancelDone = payload => ({ type: types.BILLING_SUBSCRIPTION_CANCEL_DONE, payload });
export const billingSubscriptionCancelFailed = payload => ({ type: types.BILLING_SUBSCRIPTION_CANCEL_FAILED, payload });
export const billingSubscriptionCancelReset = () => ({ type: types.BILLING_SUBSCRIPTION_CANCEL_RESET });
